import { Component } from '@angular/core';
import { FeatureTogglesFacade } from '@cigna/shared/angular/features-feature';

interface ResourceLink {
  title: string;
  body: string;
  url: string;
  urlName: string;
  linkType: 'page' | 'file';
  resourceContext: 'evernorth' | 'chcp' | 'external';
}
@Component({
  selector: 'cigna-resource-links',
  templateUrl: './resource-links.component.html',
  styleUrls: ['./resource-links.component.scss'],
})
export class ResourceLinksComponent {
  constructor(private featureToggleFacade: FeatureTogglesFacade) {}

  verifyCoverageLink$ = this.featureToggleFacade.featuresEnabled([
    'ftr-chcp-global-team-web-epp-login-resource-verify-coverage',
  ]);

  links: ResourceLink[] = [
    {
      title: 'Frequently asked questions',
      body: 'Information for providers about the change from Cigna Behavioral Health, Inc. to Evernorth Behavioral Health, Inc.',
      url: '/resourceLibrary/behavioralResources/faq',
      linkType: 'page',
      urlName: 'Evernorth FAQs',
      resourceContext: 'evernorth',
    },
    {
      title: 'Provider notification',
      body: 'Letter sent to Cigna-participating behavioral providers about the change to Evernorth Behavioral Health, Inc.',
      url: '/pdf/resourceLibrary/behavioral/provider-notification.pdf',
      urlName: 'Provider notification letter',
      linkType: 'file',
      resourceContext: 'evernorth',
    },
    {
      title: 'Employee Assistance Program',
      body: 'Employee Assistance Program (EAP) benefits are not processed through this website. Visit our EAP resources page to learn more about administering these benefits.',
      url: '/resourceLibrary/behavioralResources/eap',
      urlName: 'EAP resources',
      linkType: 'page',
      resourceContext: 'evernorth',
    },
    {
      title: 'Provider Newsroom',
      body: 'Check out the Provider Newsroom, which features news and updates on topics that are most important to you. Get acquainted with the Provider Newsroom, take a <a target="_blank" href="https://providernewsroom.com/cigna-healthcare/welcome-to-the-provider-newsroom/?brand=evernorth">virtual tour</a>, and view current content.',
      url: 'https://providernewsroom.com/category/evernorth',
      urlName: 'Provider Newsroom',
      linkType: 'page',
      resourceContext: 'external',
    },
    {
      title: 'Get questions answered',
      body: 'Our Resource library has access to many forms and information that you can access before logging in.',
      url: '/resourceLibrary/resourceLibrary',
      urlName: 'Resource library',
      linkType: 'page',
      resourceContext: 'evernorth',
    },
    {
      title: 'Join the network',
      body: 'Become a participating behavioral provider today!',
      url: '/resourceLibrary/behavioralResources/doingBusinessWithUs/cbhCredentialing',
      urlName: 'Join the network',
      linkType: 'page',
      resourceContext: 'evernorth',
    },
    {
      title: 'Find the right forms',
      body: 'Quickly locate the forms you need for authorizations, referrals, or filing or appealing claims with our Forms resource area.',
      url: '/resourceLibrary/forms/formsCBHListing',
      urlName: 'Forms Center',
      linkType: 'page',
      resourceContext: 'evernorth',
    },
    {
      title: 'Review coverage policies',
      body: 'Access information on Cigna standard health coverage plan provisions and medical coverage policies with our extensive Coverage Policies resource area.',
      url: '/resourceLibrary/coveragePolicies/index',
      urlName: 'Coverage Policies',
      linkType: 'page',
      resourceContext: 'chcp',
    },
    {
      title: 'Review clinical reimbursement and payment policies',
      body: 'Find appeal policies, claim editing procedures and laboratory and reimbursement information critical to working with Cigna.',
      url: '/resourceLibrary/clinicalReimbursementPayment/clinReimAndPayPolsListing',
      urlName: 'Clinical Reimbursement and Payment Policies',
      linkType: 'page',
      resourceContext: 'chcp',
    },
    {
      title: 'Precertification process',
      body: 'Learn what services require precertification and how to properly request it for medications, medical procedures, and services managed by delegated ancillary vendors.',
      url: '/resourceLibrary/preCertification/preCertification',
      urlName: 'Precertification',
      linkType: 'page',
      resourceContext: 'chcp',
    },
    {
      title: 'Find care for patients',
      body: 'Find a health care professional in your patients’ network. Select a directory, and find network participating health care professionals that best fit your patients’ needs, based on their coverage.',
      url: 'https://well.evernorth.com/public/directory',
      urlName: 'Find a health care professional',
      linkType: 'page',
      resourceContext: 'external',
    },
  ];
}
